<template>
    <div class="confirmation-popup">
        <div class="popup-content">
            <p>{{ message }}</p>
            <button class="btn btn-primary" @click="cancel">Annulla</button>
            <button class="btn btn-danger" @click="confirm">Conferma</button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        message: String
    },
    methods: {
        confirm() {
            this.$emit('confirmed');
        },
        cancel() {
            this.$emit('canceled');
        }
    }
};
</script>
<style scoped>
.confirmation-popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.popup-content {
    background-color: var(--primary-color);
    color: var(--text-color);
    padding: 20px;
    border-radius: 5px;
    text-align: center;
}

.popup-content p {
    margin-bottom: 10px;
}

.popup-content button {
    margin: 10px;
}
</style>